import { batch } from 'react-redux'

import { setEmail } from 'store/actions/email'
import { setUser } from 'store/actions/user'

export const afterSignIn = (response) => {
  return (dispatch) => {
    batch(() => {
      dispatch(setUser(response))
      dispatch(setEmail(null))
    })
  }
}
